"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMMEDIATE_INTAKE_BOOKING_RESPONSE_EXAMPLE = exports.APPOINTMENT_BOOKING_RESPONSE_EXAMPLE = void 0;
/**
 * Response DTOs for the 8 Booking endpoints — mirrors
 * `BookingApplicationService`'s own `BookingResultDto<TResult>`
 * (backend, frozen, Stage 5B.4): 6 endpoints wrap `AppointmentDto`,
 * the other 2 (Walk-in/Emergency) wrap `ImmediateQueueEntryResponseDto`
 * since ADR-022 gives them no `Appointment` row at all.
 */
const appointment_common_response_1 = require("./appointment-common.response");
exports.APPOINTMENT_BOOKING_RESPONSE_EXAMPLE = {
    result: appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE,
    reminderScheduled: false,
    notificationSent: false,
};
exports.IMMEDIATE_INTAKE_BOOKING_RESPONSE_EXAMPLE = {
    result: appointment_common_response_1.IMMEDIATE_QUEUE_ENTRY_RESPONSE_EXAMPLE,
    reminderScheduled: false,
    notificationSent: false,
};
//# sourceMappingURL=booking.response.js.map